import React from 'react';
import './Experience.scss';

const Experience = () => {
  return (
    <section className="experience-section" id="tecrubeuzmanlik">
      <div className="container">
        <div className="experience-content" data-aos="fade-up" data-aos-duration="900">
          <h2>Tecrübe ve Uzmanlığı Teknolojiye Aktarma Zamanı, Teknolojide Hayat Etkisi</h2>
          
          {/* Sadece mobil görünümde gösterilecek görsel */}
          <div className="experience-image-mobile">
            <img src="images/experience-image.jpg" alt="Tecrübe ve Uzmanlık" />
          </div>
          
          <div className="stats-container">
            <div className="row-1">
              <div className="stat-card">
                <div className="stat-title">Veri ve İş Analitiği</div>
                <div className="stat-text">Karar alma süreçlerini güçlendirmek için verileri anlamlandırır, içgörüye dönüştürür ve stratejiye yön veririz.</div>
              </div>
              
              <div className="stat-card">
                <div className="stat-title">Pazarlama Analitiği</div>
                <div className="stat-text">Doğru hedef kitleye en etkili şekilde ulaşmak için müşteri verilerini analiz eder, kampanyaları veriye dayalı optimize ederiz.</div>
              </div>
            </div>
            
            <div className="row-2">
              <div className="stat-card">
                <div className="stat-title">Yapay Zeka</div>
                <div className="stat-text">Gelişmiş algoritmalar ve makine öğrenimiyle karar süreçlerini otomatikleştirir, yüksek verimlilik ve isabetli öngörüler sağlarız.</div>
              </div>
              
              <div className="stat-card">
                <div className="stat-title">Kişiselleştirilmiş Hizmetler</div>
                <div className="stat-text">Gerçek zamanlı veri ve yapay zeka desteğiyle kullanıcı deneyimini kişiye özel hale getirir, etkileşimi derinleştiririz.</div>
              </div>
            </div>
          </div>
        </div>

        {/* Masaüstü ve tablet görünümünde gösterilecek görsel */}
        <div className="experience-image" data-aos="fade-up" data-aos-duration="900">
          <img src="images/experience-image.jpg" alt="Tecrübe ve Uzmanlık" />
        </div>
      </div>
    </section>
  );
};

export default Experience;
